import "./CompanyDetails.css";

import { useState } from "react";
import { useDispatch } from "react-redux";

import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IconButton, Tooltip } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import TextField from "@mui/material/TextField";

import CommonLink from "components/Link/CommonLink";
import CompanyCodeInfo from "pages/EstimateViewer/KatsViewer/components/InnKppModal/CompanyCodeInfo";
import CompanyGeneralInfo from "pages/EstimateViewer/KatsViewer/components/InnKppModal/CompanyGeneralInfo";
import { editCurItemOffer } from "slices/som/somSlice";

const CompanyDetails = ({ rowObj }) => {
	const dispatch = useDispatch();
	const [webSite, setWebSite] = useState(rowObj.company_website || "");
	const [isCompanyWebsiteEditing, setIsCompanyWebsiteEditing] = useState(false);

	const commonWebSite = () => {
		return <CommonLink urlStr={rowObj.company_website} />;
	};

	const finishEditing = () => {
		setIsCompanyWebsiteEditing(false);
		dispatch(editCurItemOffer({ offerId: rowObj.id, offerObj: { ...rowObj, company_website: webSite } }));
	};

	const editingWebSite = () => {
		return (
			<span className="CompanyDetailsLinkText">
				<TextField
					autoFocus
					sx={{ width: "100%" }}
					size="small"
					label=""
					value={webSite || ""}
					variant="standard"
					onChange={(e) => {
						if (e.target.value != null) setWebSite(e.target.value);
					}}
					InputLabelProps={{ shrink: true }}
					onBlur={() => finishEditing()}
					onKeyDown={(e) => {
						if (e.key === "Enter") finishEditing();
					}}
				/>
			</span>
		);
	};
	return (
		<>
			<tr className="CompanyDetails">
				<td colSpan={7} style={{ borderLeft: "1px solid #dddddd", borderRight: "1px solid #dddddd" }}>
					<div className="CompanyInfo">
						<div className="CompanyGeneralInfo">
							<Accordion defaultExpanded>
								<AccordionSummary expandIcon={<ExpandMoreIcon />}>
									<div>Общие сведения</div>
								</AccordionSummary>
								<AccordionDetails>
									<CompanyGeneralInfo data={rowObj} />
								</AccordionDetails>
							</Accordion>
						</div>
						<div className="CompanyLinkInfo">
							<Accordion defaultExpanded>
								<AccordionSummary expandIcon={<ExpandMoreIcon />}>
									<div>Ссылка на сайт организации</div>
								</AccordionSummary>
								<AccordionDetails>
									<div className="CompanyDetailsBox">
										{isCompanyWebsiteEditing ? editingWebSite() : commonWebSite()}
										<span className="CompanyDetailsLinkButton">
											<Tooltip title="Изменить" onClick={() => setIsCompanyWebsiteEditing(true)}>
												<IconButton size="small">
													<EditOutlinedIcon />
												</IconButton>
											</Tooltip>
											<Tooltip
												title="Удалить"
												onClick={() => {
													dispatch(editCurItemOffer({ offerId: rowObj.id, offerObj: { ...rowObj, company_website: "" } }));
												}}
											>
												<IconButton size="small">
													<CancelOutlinedIcon />
												</IconButton>
											</Tooltip>
										</span>
									</div>
								</AccordionDetails>
							</Accordion>
						</div>
						<div className="CompanyCodeInfo">
							<Accordion defaultExpanded>
								<AccordionSummary expandIcon={<ExpandMoreIcon />}>
									<div>Коды статистики и вид деятельности</div>
								</AccordionSummary>
								<AccordionDetails>
									<CompanyCodeInfo data={rowObj} />
								</AccordionDetails>
							</Accordion>
						</div>
					</div>
				</td>
			</tr>
		</>
	);
};

export default CompanyDetails;
